import React from 'react';
import './Overlay.css';

export default function Overlay(props) {
  return (
    <div id="overlay" className="Overlay normal-1x fadeIn" onClick={props.onClick}>
    </div>
  )
}
